import React, { Component } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import { log } from "../../utils/log";
import AtividadeAluno from "../Statistics/AtividadeAluno";
import AlunoTurma from "../Statistics/Comparison/AlunoTurma";

import "./style.css";

class UserStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      // loading: true,
      // applications: [],
      menu: "Atividades do estudante"
    };
  }

  async componentDidMount() {
    this.createLog();

    const respRoomUser = await axios.get(
      `${URL.api}community/room_user/report?room_user_id=${this.props.roomUser}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({
      roomUser: respRoomUser.data.data
    });
  }

  getMenus() {
    return [
      {
        name: "Atividades do estudante",
        component: <AtividadeAluno roomUser={this.state.roomUser} />
      },
      {
        name: "Comparação do estudante x turma",
        component: <AlunoTurma roomUser={this.state.roomUser} />
      }
    ];
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas do usuário ${this.props.username}`,
      this.props.userId,
      this.props.user.token,
      null,
      this.props.general.active_roles.school_id || null
    );
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Estatísticas do estudante - {this.props.username}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus().map(menu => (
              <CListGroupItem
                action
                active={menu.name === this.state.menu}
                style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                className="cursor"
                onClick={() => this.setState({ menu: menu.name })}
              >
                {menu.name}
              </CListGroupItem>
            ))}
          </CListGroup>
          <div
            className="p-3 charts flex-1 d-flex flex-column align-items-center"
            style={{ overflow: "auto" }}
          >
            <span className="est-text mb-3">
              <h1>{this.state.menu}</h1>
            </span>
            {
              this.getMenus().find(menu => menu.name === this.state.menu)
                .component
            }
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserStatistics);
